import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    // 錯誤網址會導至登入面

    path: '*',
    redirect: '/login',
  },

  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/logout.vue'),
  },

  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth.vue'),
    meta: {
      title: '展昭會員帳號綁定 - 展昭展覽網',
    },
  },

  {
    path: '/en',
    name: 'en',
    redirect: '/en/login',

    component: () => import('@/views/en/enLayout.vue'),

    children: [
      {
        path: 'login',
        name: 'login_en',
        component: () => import('@/views/en/login_en.vue'),
        meta: {
          title: 'Login - Chan Chao Exhibition Hall',
        },
      },
      {
        path: 'resetPw',
        name: 'resetPw',
        component: () => import('@/views/en/resetPw_en.vue'),
        meta: {
          title: 'Reset Password - Chan Chao Exhibition Hall',
        },
      },

      {
        path: 'forgetPw',
        name: 'forgetPw',
        component: () => import('@/views/en/forgetPw_en.vue'),
        meta: {
          title: 'Forgot Password - Chan Chao Exhibition Hall',
        },
      },

      {
        path: 'signup',
        name: 'signup',
        component: () => import('@/views/en/signup_en.vue'),
        meta: {
          title: 'Sign Up - Chan Chao Exhibition Hall',
        },
      },
    ],
  },

  {
    path: '/vn',
    name: 'vn',
    redirect: '/vn/login',

    component: () => import('@/views/vn/vnLayout.vue'),

    children: [
      {
        path: 'login',
        name: 'login_vn',
        component: () => import('@/views/vn/login_vn.vue'),
        meta: {
          title: 'đăng nhập - Triển lãm Chan Chao',
        },
      },
      {
        path: 'resetPw',
        name: 'resetPw_vn',
        component: () => import('@/views/vn/resetPw_vn.vue'),
        meta: {
          title: 'Cài đặt lại mật khẩu - Triển lãm Chan Chao',
        },
      },

      {
        path: 'forgetPw',
        name: 'forgetPw_vn',
        component: () => import('@/views/vn/forgetPw_vn.vue'),
        meta: {
          title: 'Quên mật khẩu - Triển lãm Chan Chao',
        },
      },

      {
        path: 'signup',
        name: 'signup_vn',
        component: () => import('@/views/vn/signup_vn.vue'),
        meta: {
          title: 'Đăng ký - Triển lãm Chan Chao',
        },
      },
    ],
  },

  {
    path: '/th',
    name: 'th',
    redirect: '/th/login',

    component: () => import('@/views/th/thLayout.vue'),

    children: [
      {
        path: 'login',
        name: 'login_th',
        component: () => import('@/views/th/login_th.vue'),
        meta: {
          title: 'ออกจากระบบ - Chan Chao Exhibition Hall',
        },
      },
      {
        path: 'resetPw',
        name: 'resetPw_th',
        component: () => import('@/views/th/resetPw_th.vue'),
        meta: {
          title: 'แก้ไขรหัสผ่าน - Chan Chao Exhibition Hall',
        },
      },

      {
        path: 'forgetPw',
        name: 'forgetPw_th',
        component: () => import('@/views/th/forgetPw_th.vue'),
        meta: {
          title: 'ลืมรหัสผ่าน - Chan Chao Exhibition Hall',
        },
      },

      {
        path: 'signup',
        name: 'signup_th',
        component: () => import('@/views/th/signup_th.vue'),
        meta: {
          title: 'ลงทะเบียน - Chan Chao Exhibition Hall',
        },
      },
    ],
  },

  {
    path: '/',
    name: 'Layout',
    redirect: '/login',
    component: () => import('@/views/cn/cnLayout.vue'),

    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/cn/login.vue'),
        meta: {
          title: '會員登入 - 展昭展覽網',
        },
      },

      {
        path: 'signup',
        name: 'signup',
        component: () => import('@/views/cn/signup.vue'),
        meta: {
          title: '會員註冊 - 展昭展覽網',
        },
      },

      {
        path: 'signup_line',
        name: 'signup_line',
        component: () => import('@/views/cn/signup_line.vue'),
        meta: {
          title: '用LINE帳號進行會員註冊 - 展昭展覽網',
        },
      },

      {
        path: 'resetPw',
        name: 'resetPw',
        component: () => import('@/views/cn/resetPw.vue'),
        meta: {
          title: '重設密碼 - 展昭展覽網',
        },
      },

      {
        path: 'forgetPw',
        name: 'forgetPw',
        component: () => import('@/views/cn/forgetPw.vue'),
        meta: {
          title: '忘記密碼 - 展昭展覽網',
        },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/accounts/',
  routes,

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

export default router
